import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-calendar';
import Button from '../elements/button';
import FormInput from '../elements/form_input';

export const AppointmentModal = ({ doctor, onSubmit, onClose }) => {
    const [appointment, setAppointment] = useState({
        date: new Date(),
        time: '',
        reason: ''
    });

    return (
        <div className="modal-overlay">
            <div className="modal-content appointment-form">
                <h2>Book Appointment with {doctor.name}</h2>
                
                <form onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit(appointment);
                }}>
                    <Calendar
                        onChange={(date) => setAppointment({...appointment, date})}
                        value={appointment.date}
                        minDate={new Date()}
                    />
                    
                    <FormInput
                        label="Preferred Time"
                        type="time"
                        value={appointment.time}
                        onChange={(e) => setAppointment({
                            ...appointment,
                            time: e.target.value
                        })}
                        required
                    />
                    
                    <FormInput
                        label="Reason for Visit"
                        value={appointment.reason}
                        onChange={(e) => setAppointment({
                            ...appointment,
                            reason: e.target.value
                        })}
                        required
                    />
                    
                    <div className="modal-actions">
                        <Button
                            text="Cancel"
                            variant="outline"
                            onClick={onClose}
                        />
                        <Button
                            text="Book Appointment"
                            type="submit"
                            variant="primary"
                        />
                    </div>
                </form>
        </div>
    </div>
    );
};

AppointmentModal.propTypes = {
    doctor: PropTypes.shape({
        name: PropTypes.string
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
}; 

export default AppointmentModal;